import {lazy} from "../../lib/lazy.js";
export const productAkulakuRoutes = [
  {
    path: "/product-akulaku",
    component: lazy(() => import(/* webpackChunkName: "productShopeeRoutes" */ "../../views/product-akulaku/list/index.js")),
    auth: "list-product"
  }
];
